import { styled } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";

interface StyledInputAdornmentProps {
  value?: string;
  disabled?: boolean;
}

const StyledInputAdornment = styled(InputAdornment)<StyledInputAdornmentProps>`
  color: ${(props) => props.theme.wsc.palette.neutral[200]};

  ${(props) =>
    props.value &&
    `
        color: ${props.theme.wsc.palette.neutral[100]}
    `};

  ${(props) =>
    props.disabled &&
    `
        color: ${props.theme.wsc.palette.neutral[400]};
    `};
`;

export default StyledInputAdornment;
